
















































import Vue from 'vue';
import moment from 'moment';
import { getMessageById } from '@/utils/message';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Vue.extend<any, any, any, any>({
  name: 'CtrlDatePickerMonth',
  props: {
    label: {
      type: String,
      default: '年月',
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    offset: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: String,
      default: '80px',
    },
    value: {
      type: [Number, String],
    },
  },
  data: () => ({
    displayDate: '',
    beforeDate: '',
    menu: false,
  }),

  methods: {
    numDate(date: string) {
      if (!date) return '';
      if (date.indexOf('-') < 0) return date;
      const [year, month] = date.split('-');
      return `${year}${month}`;
    },

    hyphenDate(date: string | number) {
      if (!date) return '';
      if (typeof date === 'number') {
        date = date.toString();
      }
      if (date.indexOf('-') >= 0) return date;
      if (date.length === 2) {
        let y = new Date().getFullYear();
        let m = date.substr(0, 2);
        return `${y}-${m}`;
      } else if (date.length === 6) {
        let y = date.substr(0, 4);
        let m = date.substr(4, 2);
        return `${y}-${m}`;
      } else {
        return date;
      }
    },
    handleChangeDate(val: string) {
      this.menu = false;
      // Convert the string to a Date object
      const date = new Date(val);
      // Get the year from the Date object
      const year = date.getFullYear();
      // Check if the year is less than 2020 or greater than 2099
      if (year < 2020 || year > 2099) {
        this.displayDate = '';
        this.$emit('input', '');
      } else {
        this.displayDate = val;
        this.$emit('input', val);
      }
    },
    handleOnInput(val: string) {
      return val.replace(/\D/g, '');
    },
    handleOnBlur() {
      if (!this.displayDate || this.displayDate === '') {
        this.$emit('input', null);
        return;
      }
      let date = this.displayDate.replace(/\D/g, '');
      if (moment(date, ['YYYY-MM', 'YYYYMM', 'MM'], true).isValid()) {
        if(date < 202001 || date > 209912) date = '';
        this.displayDate = this.hyphenDate(date);
        this.$emit('input', this.hyphenDate(date));
      } else {
        this.$emit('input', null);
      }
    },
    handleOnFocus(focusEvent: any) {
      if (this.readonly) return;
      this.beforeDate = this.displayDate;
      this.displayDate = this.numDate(this.displayDate) || '';
      this.$nextTick(function () {
        focusEvent.target.select();
      });
    },
  },
  computed: {
    computedWidth() {
      return `max-width: ${this.maxWidth}`;
    },
    computedDate() {
      return this.hyphenDate(this.value);
    },
    computedReadOnly() {
      return this.menu ? true : this.readonly;
    },
    isValid() {
      return (value: string) => {
        const formats = ['YYYY-MM', 'YYYYMM', 'MM'];
        if (value) {
          return (
            moment(value, formats, true).isValid() || getMessageById('KI_W009')
          );
        } else {
          if (this.required) {
            return getMessageById('KI_W007');
          }
          return true;
        }
      };
    },
  },
  watch: {
    value(newVal) {
      this.displayDate = this.hyphenDate(newVal);
    },
  },
  mounted() {
    // 画面描画時に 使用画面の設定値を初期表示する
    this.displayDate = this.hyphenDate(this.value);
  },
});
